export default [
  {
    path: '/advertisers',
    name: 'PageAdvertisersList',
    meta: { title: 'advertisers.listTitle', roles: ['ADMIN'] },
    component: () => import('@/pages/advertisers'),
  },
  {
    path: '/advertisers/create',
    name: 'PageAdvertisersCreate',
    meta: { title: 'advertisers.createFormTitle', roles: ['ADMIN'] },
    component: () => import('@/pages/advertisers/create'),
  },
  {
    path: '/advertisers/:id/edit',
    name: 'PageAdvertisersEdit',
    meta: { title: 'advertisers.editFormTitle', roles: ['ADMIN'] },
    component: () => import('@/pages/advertisers/id/edit'),
  },
]
